var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 153 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#filter0_i_5524_7478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ED5D",
    d: "M66.146 132.599 0 66.452 66.146.306 76.66 10.82c-5.635 13.017-3.457 28.261 6.732 38.388 10.138 10.077 25.336 12.23 38.333 6.676l10.568 10.568-11.096 11.097c10.153 13.3 10.101 31.312-.834 42.246-10.934 10.935-29.001 11.041-42.373.96l-11.844 11.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M66.146 132.599 0 66.452 66.146.306 76.66 10.82c-5.635 13.017-3.457 28.261 6.732 38.388 10.138 10.077 25.336 12.23 38.333 6.676l10.568 10.568-11.096 11.097c10.153 13.3 10.101 31.312-.834 42.246-10.934 10.935-29.001 11.041-42.373.96l-11.844 11.844Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5524_7478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90D54C",
    d: "M29.849 76.613c.178 0 .356-.178.535-.534.178-.356.267-.94.267-1.754V56.017c0-.814-.09-1.386-.267-1.716-.179-.356-.357-.547-.535-.573h14.289c1.987 0 3.54.23 4.661.687 1.121.458 1.91 1.119 2.37 1.983.458.84.687 1.831.687 2.975 0 .916-.166 1.691-.497 2.327-.306.61-.7 1.093-1.184 1.45a5.906 5.906 0 0 1-1.452.8v.076c1.656.382 2.904 1.068 3.744 2.06.84.966 1.261 2.263 1.261 3.89a8.003 8.003 0 0 1-.65 3.166c-.433 1.017-1.235 1.856-2.407 2.517-1.146.636-2.814.954-5.005.954H29.85Zm8.214-4.234h5.731c1.452 0 2.484-.203 3.095-.61.637-.432.955-1.119.955-2.06 0-.89-.344-1.576-1.032-2.06-.687-.508-1.82-.762-3.4-.762h-5.31c-.765 0-1.223.05-1.376.153-.127.101-.191.445-.191 1.03v3.165c0 .56.064.89.19.992.154.101.6.152 1.338.152Zm.038-9.382h4.509c1.222 0 2.088-.204 2.598-.61.535-.433.802-1.069.802-1.908s-.255-1.462-.764-1.868c-.484-.407-1.35-.61-2.598-.61h-4.585c-.764 0-1.21.05-1.337.152-.127.076-.191.407-.191.992v2.707c0 .56.064.89.19.992.154.102.612.153 1.376.153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5524_7478",
    width: 134.293,
    height: 136.293,
    x: 0,
    y: 0.306,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5524_7478",
    width: 24.879,
    height: 23.885,
    x: 29.849,
    y: 53.728,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7478"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBInactive);
export default __webpack_public_path__ + "static/media/b_inactive.d6ce71b43dfeecb3c84d6bc13a95432d.svg";
export { ForwardRef as ReactComponent };